import {
  compose,
  withPropsOnChange,
  branch,
} from 'recompose'
import { connect } from 'react-redux'
import { getFormValues, change } from 'redux-form'

import * as R from 'ramda'
import get from 'lodash/get'

import { toirStatusesTransport } from './toirStatusesTransport'
import { toirIssueTransport } from './toirIssueTransport'
import prepareToirIssueForWidget from './prepareToirIssueForWidget'
import { withEquipment, equipmentDataPropName } from '../../EquipmentFormatter'

const withToirIssueOnForm = compose(
  toirStatusesTransport,
  connect((state, { form }) => ({
    toirIssueId: get(getFormValues(form)(state), `esuz`),
  }),
  (dispatch, { form }) => ({
    changeFormValue: (field, value) => dispatch(change(form, field, value)),
  })),
  branch(
    ({ toirIssueId }) => toirIssueId,
    toirIssueTransport,
  ),
  withPropsOnChange([`toirIssues`, `toirStatuses`], ({ setIssueLinkData, toirIssues, toirStatuses }) => {
    if (!R.isEmpty(toirIssues) && !R.isEmpty(toirStatuses)) {
      const tempIssue = R.head(prepareToirIssueForWidget(toirIssues, toirStatuses))
      setIssueLinkData(tempIssue)
    } else {
      setIssueLinkData({})
    }
  }),
  withPropsOnChange([`issueLink`], ({ issueLink }) => {
    const entityId = R.path([`customFields`, `object_code`], issueLink)

    return {
      entityId,
      errorComponent: () => entityId || `Нет данных`,
    }
  }),
  branch(
    ({ entityId }) => entityId,
    compose(
      withEquipment,
      withPropsOnChange([equipmentDataPropName], ({ [equipmentDataPropName]: equipment, changeFormValue }) => {
        const objectId = R.prop(`code`, equipment)
        const object = R.prop(`info`, equipment)
        changeFormValue(`objectId`, objectId)
        changeFormValue(`object`, object)
      }),
    ),
  ),
)

export default withToirIssueOnForm
